import axios from 'axios';
import React, { Component } from 'react'
import CollapsibleCard from './CollapsibleCard';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import { LoadingButton } from '@mui/lab';
import Box from '@mui/material/Box';

export default class OrderDeliver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      alert: null,
      pageReady: false,
      errorMsg: '',
      borrowerName: '',
      borrowerAddress: '',
      invoiceNumber: this.props.orderID,
      invoiceDate: '',
      paymentDate: '',
      inspectionType: '',
      propertyAddress: '',
      totalPayment: '',
      allPaid: 'False',
      lineItems: [],
      docType: 'Select...'
    };
  }

  async _deliverReport() {
    try {
      // send completed report
      var response = axios.get('/sendcompletedreport', { params: { pOrderID: this.props.order.orderID }});
      var resultData = (await response).data;
      if(!resultData.startsWith('Success'))
        this.setState({alert: 'Error Updating Order Status to Complete!'});
      this.setState({submitting: false});
      this.props.afterCompleted();
    }
    catch { this.setState({alert: 'Error Completing Report!', submitting: false}); }
  }

  captureInput = e => {
    this.setState({[e.target.name]: e.target.value});
  }

  render() {
    const { alert, submitted, pageReady, submitting } = this.state;
    return (
      <CollapsibleCard title="Complete Order">
        {alert && <Alert severity="info" sx={{ mb: 2 }}>{alert}</Alert>}
        {submitted ? <Box>
          <Typography paragraph textAlign="center">Report Delivered to Lender! ({submitted})</Typography>
        </Box> : (<>
          <List sx={{ width: '100%' }}>
            <Stack pt={2} alignItems="end">
              <LoadingButton
                variant="contained"
                loading={!pageReady || submitting}
                onClick={() => this._deliverReport()}
                disabled={this.state.payAtClosing}
              >Mark Completed</LoadingButton>
            </Stack>
          </List>
        </>)}
      </CollapsibleCard>
    );
  }
}